<template>
  <router-view />
</template>

<script>
export default {
  name: 'Prematch',
};
</script>
